<template>
<v-app>
<resizable-page>
  <template v-slot:table="tableProps">
  <v-card>
    <v-card-title>
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>
    <v-data-table
      mobile-breakpoint
      :headers="headers"
      :items="table"
      :search="search"
      :loading="loadTable"
      loading-text="Loading... Please wait"
      ref="vTable"
      :height="tableProps.tableHeight"
      fixed-header
      :footer-props="{'items-per-page-options':[5,15, 30, 50, 100]}"
    >
    <template v-slot:item="{ item }">
        <tr  @click="onSelect(item)">
            <td>{{item.vehicle_door_no}}</td>
            <td>{{item.vehicle_plate_no}}</td>
            <td>
              <span v-if="item.vehicle_pool == 0">Pool Bekasi</span>
              <span v-else-if="item.vehicle_pool == 1">Etc</span>
            </td>
            <td>{{item.vehicle_business_unit.business_unit_name}}</td>
            <td>{{ "("+item.vehicle_type.vehicle_brands.vehicle_brand_name+") "+' '+ item.vehicle_type.vehicle_model+' '+ item.vehicle_type.vehicle_year_model }}</td>
            
            <td>
              <span v-if="item.vehicle_body_color == 0">Putih</span>
              <span v-else-if="item.vehicle_body_color == 1">Putih Kuning</span>
              <span v-else-if="item.vehicle_body_color == 2">Putih Metalik</span>
              <span v-else-if="item.vehicle_body_color == 3">Hitam</span>
              <span v-else-if="item.vehicle_body_color == 4">Hitam Metalik</span>
              <span v-else-if="item.vehicle_body_color == 5">Silver</span>
              <span v-else-if="item.vehicle_body_color == 6">Silver Metalik</span>
              <span v-else-if="item.vehicle_body_color == 7">Abu Abu</span>
              <span v-else-if="item.vehicle_body_color == 8">Abu Abu Metalik</span>
              <span v-else-if="item.vehicle_body_color == 9">N/A</span>
            </td>
            <td>{{item.vehicle_production_year}}</td>
            <td>{{item.vehicle_registration_year}}</td>
            <td>
              <span v-if="item.vehicle_plate_color == 0">Kuning</span>
              <span v-else-if="item.vehicle_plate_color == 1">Hitam</span>
            </td>
            <td>{{item.vehicle_registration_name}}</td>
            <td>{{item.vehicle_engine_no}}</td>
            <td>{{item.vehicle_chassis_no}}</td>
            
        </tr>
    </template>
    
    </v-data-table>
  </v-card>
    </template>
  </resizable-page>
  </v-app>
</template>

<script>
import vuetify from '@/plugins/vuetify'
import { ResizablePage } from "@/components";

  export default {
    vuetify,
    components: {ResizablePage
  },
     props: {
    data_id: null,
    },
    data () {
      return {
        loadTable: true,
        search: '',
        headers: [
          // {
          //   text: 'Client No.',
          //   align: 'start fixed',
          //   value: 'client_no',
          // },
          { text: 'Vehicle No', value: 'vehicle_door_no' },
          { text: 'Plate No', value: 'vehicle_plate_no' },
          { text: 'Pool', value: 'vehicle_pool' },
          { text: 'Business unit', value: 'vehicle_business_unit' },
          { text: 'Model', value: 'vehicle_type.vehicle_model' },
          { text: 'Body Color', value: 'vehicle_body_color' },
          { text: 'Production Year', value: 'vehicle_production_year' },
          { text: 'Registration Year', value: 'vehicle_registration_year' },
          { text: 'Plate Color', value: 'vehicle_plate_color' },
          { text: 'Registration Name', value: 'vehicle_registration_name' },
          { text: 'Engine No', value: 'vehicle_engine_no' },
          { text: 'Chassis No', value: 'vehicle_chassis_no' },
        ],
        table: [],
      }
    },
    async created() {
      
    this.getList();
    },
     methods: {
       // ambil data yang dibutuhkan
    async getList() { 
      
      // if (await this.$store.getters["bizdev_client/list"].length!=0) {
         await this.$store.dispatch("fms_vehicle/list")
      // }
      this.table = await this.$store.getters["fms_vehicle/list"]
      this.loadTable= false
    },

    //fungsi yang ada di parent di panggil saat memilih row di table
    onSelect (item) {
    this.$parent.$parent.$parent.modalCloseList(item)
      },

     },

     
  }
</script>
<style>
.v-application--wrap {
  min-height: unset;
}
.v-list-item__title {
    font-size: 0.8rem;
}
.v-menu__content{
    z-index: 10 !important;
}
table > tbody > tr > td.fixed:nth-child(1), 
  table > thead > tr > th.fixed:nth-child(1) {
    position: sticky !important; 
    position: -webkit-sticky !important; 
    left: 0; 
    z-index: 9998;
    background: white;
  }
  table > thead > tr > th.fixed:nth-child(1) {
    z-index: 9999;
  }
</style>